/*
 * Filename: d:\projects\AutoFiFront\src\Theme\Component\CarCost.tsx
 * Path: d:\projects\AutoFiFront
 * Created Date: Monday, February 13th 2023, 5:00:45 pm
 * Author: Jonathan MAZAT
 *
 * Copyright (c) 2023 Autobuy SAS
 */
import styled from "styled-components";

const CarCostSellPrice = styled.div.attrs(props => ({
    fontColor: props.fontColor,
}))`
display: flex;
justify-content: center;
align-items: center;
position: relative;
top: -0.4rem;
left: 7rem;
margin-bottom: 0;
max-width: 75px;
height: 2rem;
font-family: var(--theme-text-Montserrat-semi-bold);
border-radius: 5px;
color: ${props => props.fontColor == "CITYCAR" ? props.theme.colors.second : props.fontColor == "SUV" ? props.theme.colors.third : props.fontColor == "UTILITY" ? props.theme.colors.fourth : props.fontColor == "SEDAN" ? props.theme.colors.fifth : props.fontColor == "BREAK" ? props.theme.colors.sixth : props.theme.colors.first};
background-color: var(--bg-color-first);
`;

export default CarCostSellPrice;
